import { Heading } from 'react-aria-components';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

// Components
import AppFooter from 'components/app-footer';
import AppHeader from 'components/app-header';
import Loader from 'components/loader';
import PageLayout from 'components/layout/page-layout';
import { PAGES } from 'constants/pages';
import { RouterLink as Link } from 'components/destiny/button';

// Helpers
import { useOrderDetailsV2 } from 'features/results/helpers';
import { useMyOrderDropdownOptions } from './helpers';

// Styles
import styles from './order-details.upp.module.scss';

// Feature components
import { About } from './components/about';
import { PatientInformation } from './components/patient-information';
import { PaymentInformation } from './components/payment-information';

export const OrderDetails = () => {
  const { t } = useTranslation();
  const { orderId } = useParams<{ orderId: string }>();
  const myOrderTopics = useMyOrderDropdownOptions({ disablePending: false });
  const selectedOrder = myOrderTopics.find((o) => o.key === orderId);
  const { loading, data } = useOrderDetailsV2(orderId);

  const orderDetails =
    data?.orderDetails?.__typename === 'OrderDetailsSuccess' &&
    data.orderDetails.detail?.__typename === 'OrderDetailsResponse'
      ? data.orderDetails.detail
      : undefined;

  return (
    <PageLayout header={<AppHeader />} footer={<AppFooter />}>
      <div className={styles.orderDetailsWrapper}>
        <div className={styles.myTestsLinkWrapper}>
          <Link
            to={`${PAGES.MY}${PAGES.TESTS}`}
            size="medium"
            iconLeading={faArrowLeft}
          >
            {t('labels.backToTest')}
          </Link>
        </div>
        <Heading level={1} className={styles.pageHeading}>
          {t('orders.orderDetails')}
        </Heading>
        <div className={styles.cardWrapper}>
          {selectedOrder ? (
            <div className={styles.dropdown}>
              <div className={styles.orderSelectionWrapper}>
                <div className={styles.orderSelection}>
                  {selectedOrder.description && (
                    <div className={styles.orderTestDescription}>
                      {selectedOrder.description}
                    </div>
                  )}
                  <div className={styles.orderTestName}>
                    {/* Make product name bold */}
                    {selectedOrder.label
                      ? selectedOrder.label
                          .split(' ')
                          .map((word, i) =>
                            i === 0 ? (
                              <span className={styles.product}>{word}</span>
                            ) : (
                              ` ${word}`
                            ),
                          )
                      : null}
                  </div>
                </div>
              </div>
            </div>
          ) : null}
          {loading ? (
            <div className={styles.loaderWrapper}>
              <Loader />
            </div>
          ) : null}
          {orderDetails && !loading ? (
            <>
              <PatientInformation orderDetails={orderDetails} />
              <About orderDetails={orderDetails} />
              <PaymentInformation orderDetails={orderDetails} />
            </>
          ) : null}
        </div>
      </div>
    </PageLayout>
  );
};
